import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MentionDirective } from './mention.directive';
import { MentionListComponent } from './mention-list/mention-list.component';

/**
 * Date: 2024-04-16
 * Adapted from NPM Library: [angular-mentions](https://www.npmjs.com/package/angular-mentions)
 */
@NgModule({
    declarations: [
        MentionDirective,
        MentionListComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        MentionDirective
    ]
})
export class MentionModule { }
